import { useNavigate } from "react-router-dom";
import { AuthLayout, Button, HiyaLogo } from "@hiya/ui";
import { SUPPORT_EMAIL } from "../../auth/constants";

export function ForgotPasswordPage() {
  const navigate = useNavigate();

  return (
    <AuthLayout
      title="Forgot password?"
      subtitle="Password resets are handled by your administrator."
      icon={<HiyaLogo />}
      backTo="/login"
    >
      <div className="flex flex-col gap-8 items-center w-full">
        <p className="text-base text-text-secondary text-center">
          To reset your password, please contact your administrator at{" "}
          <a href={`mailto:${SUPPORT_EMAIL}`} className="text-brand-brown underline">
            {SUPPORT_EMAIL}
          </a>.
        </p>
        <Button onClick={() => navigate("/login")}>Back to Log in</Button>
      </div>
    </AuthLayout>
  );
}
